import type { ReactNode } from 'react';

export function EmptyState({
  title,
  description,
  action,
}: {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}): JSX.Element {
  return (
    <div className="text-center py-12 px-6">
      <h3 className="text-sm font-medium text-ink">{title}</h3>
      {description && <p className="text-sm text-ink-3 mt-1">{description}</p>}
      {action && <div className="mt-4 inline-flex">{action}</div>}
    </div>
  );
}
